export {
	AUDIT_LOG_DETAILS_PANEL,
	AUDIT_LOG_PANEL_WIDTH,
	setAuditLogEvent,
	getAuditLogEvent,
	clearAuditLogEvent,
} from '../src/auditLogPanel.ts';
